<template>
  <ui-modal
    :show="showRule"
    type="tag"
    title="竞猜规则"
    iconType="quiz_2"
    @close="showRule = false"
  >
    <div class="rule-box">
      <div class="inner">
        <div class="rule" v-for="(item, key) in ruleList" :key="key">
          <div class="title">{{ item.title }}</div>
          <div class="des" v-if="item.des">{{ item.des }}</div>
          <ul v-if="item.rule">
            <li v-for="(rule, i) in item.rule" :key="i">
              <img src="https://website.xdcdn.net/poster/58881/20250717/KwuBpcqu.png">
              <span>{{ rule }}</span>
            </li>
          </ul>
        </div>
        <div class="placeholder"></div>
      </div>
    </div>
  </ui-modal>
</template>

<script>
import * as api from "@/service/index";
import { mapState } from "vuex";
import UiModal from "@/components/ui-modal.vue";

export default {
  components: {
    UiModal,
  },
  data() {
    return {
      showRule: false,
      inRequest: false,
      ruleList: [],
    };
  },
  computed: {
    ...mapState(["scale"]),
  },
  mounted() {
    this.getRule();
  },
  methods: {
    hideModal() {
      this.showRule = false;
    },
    rule() {
      this.showRule = true;
    },
    async getRule() {
      let response = await api.reqRule();
      if (response.status == 200) {
        this.ruleList = response.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/quiz/rule";
</style>